import { render, staticRenderFns } from "./VGanttRenderer.vue?vue&type=template&id=54d28716&scoped=true&"
import script from "./VGanttRenderer.vue?vue&type=script&lang=js&"
export * from "./VGanttRenderer.vue?vue&type=script&lang=js&"
import style0 from "./VGanttRenderer.vue?vue&type=style&index=0&id=54d28716&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d28716",
  null
  
)

export default component.exports